// @flow

import type { State } from '../reducers';

type GlobalState = {
  footerSettings: State,
};

export const getFooterSettings = (state: GlobalState): State => {
  const { footerSettings } = state;
  if (!footerSettings) {
    throw new Error('Missing footerSettings store.');
  }
  return footerSettings;
};

type ContactOptions = $PropertyType<State, 'contact_options'>;
export const getContactOptions = (state: GlobalState): ContactOptions => (
  getFooterSettings(state).contact_options
);

type Logos = $PropertyType<State, 'logos'>;
export const getLogos = (state: GlobalState): Logos => (
  getFooterSettings(state).logos
);

type FooterTitle = $PropertyType<State, 'footer_title'>;
export const getFooterTitle = (state: GlobalState): FooterTitle => (
  getFooterSettings(state).footer_title
);

type FooterSubtitle = $PropertyType<State, 'footer_subtitle'>;
export const getFooterSubtitle = (state: GlobalState): FooterSubtitle => (
  getFooterSettings(state).footer_subtitle
);

type Newsletter = $PropertyType<State, 'newsletter'>;
export const getNewsletter = (state: GlobalState): Newsletter => (
  getFooterSettings(state).newsletter
);

export default null;
